import { types } from "../action-types";

const initialState = {
  loading: false,
  jobs: [],
  error: {},
  titles: [],
  titleLoading: false,
};

const initialStateforUpdate = {
  loading: false,
  jobs: [],
  error: {},
  success: false,
}

const postJObReeducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_JOB_TEMPLATES_REQUESTED:
      return {
        ...state,
        loading: true,
      }
    case types.GET_JOB_TEMPLATES_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: action.payload,
        error: false,
      }
    case types.GET_JOB_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
        skillListings: [],
        error: true,
      }
    case types.GET_JOB_TITLES_REQUESTED:
      return {
        ...state,
        titleLoading: true,
      }
    case types.GET_JOB_TITLES_SUCCESS:
      return {
        ...state,
        titles: action.payload,
        titleLoading: false,
      }
    default:
      return state;
  }
};

export const UpdateJobReducer = (state = initialStateforUpdate, action) => {
  switch (action.type) {
    case types.UPDATE_JOBS_REQUESTED:
      return {
        ...state,
        loading: true,
        success: false,
      }
    case types.UPDATE_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        jobs: action.payload,
        error: false,
        success: true,
      }
    case types.UPDATE_JOBS_FAILURE:
      return {
        ...state,
        loading: false,
        jobs: [],
        error: true,
        success: false,
      }
    case types.UPDATE_JOBS_RESET:
      return {
        ...state,
        loading: false,
        jobs: [],
        error: false,
        success: false,
      }
    default:
      return state;
  }
};

export default postJObReeducer;